export default {
  getLang(state) {
    return state.lang;
  },
};
